/**
 * accessiBe widget: loaded on demand when the user first clicks the
 * footer "Accessibility" trigger, instead of on every page load.
 *
 * The first click shows a loading state and injects app.js; once
 * accessiBe renders its .acsb-widget (its delegated document-level
 * click handler is attached at the same moment), we replay the click
 * so the interface opens from that single user click.
 */
(function () {
  var ready = false;
  var loading = false;

  function setLoading(on) {
    loading = on;
    var li = document.querySelector('.accessibility-menu');
    if (li) li.classList.toggle('is-loading', on);
  }

  function inject() {
    setLoading(true);
    var s = document.createElement('script');
    var h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.async = true;
    s.onload = function () {
      acsbJS.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: false,
        hideTrigger: true,
        disableBgProcess: false,
        language: 'en',
        position: 'left',
        leadColor: '#000000',
        triggerColor: '#146ff8',
        triggerRadius: '50%',
        triggerPositionX: 'right',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'medium',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: '50%'
        }
      });
      waitForWidget(0);
    };
    s.onerror = function () {
      // network failure: allow retry on next click
      setLoading(false);
    };
    h.appendChild(s);
  }

  /**
   * accessiBe attaches its click handler on `document` (delegated) at the
   * same time it renders the hidden .acsb-widget container — poll until
   * that happens, then replay the first click so the interface opens
   * from a single user click.
   */
  function waitForWidget(attempt) {
    if (document.querySelector('.acsb-widget, .acsb-sr-alert')) {
      ready = true;
      setLoading(false);
      var t = document.querySelector('[data-acsb-custom-trigger]');
      if (t) t.click(); // acsb's delegated handler opens the interface
    } else {
      // 100ms x 100 (~10s), then keep watching at 1s intervals
      setTimeout(function () {
        waitForWidget(attempt + 1);
      }, attempt < 100 ? 100 : 1000);
    }
  }

  // Capture phase so the very first click is intercepted before
  // accessiBe binds its own handler on the same element.
  document.addEventListener(
    'click',
    function (e) {
      var t =
        e.target && e.target.closest
          ? e.target.closest('[data-acsb-custom-trigger]')
          : null;
      if (!t || ready) return; // accessiBe handles clicks from here
      e.preventDefault();
      if (!loading) inject();
    },
    true
  );
})();
